import { render, staticRenderFns } from "./SmartRampRegistration.vue?vue&type=template&id=31bf873c"
import script from "./SmartRampRegistration.vue?vue&type=script&lang=js"
export * from "./SmartRampRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports